import React from 'react';
import styles from './ContentsHeader.module.scss';

type Props = {
  title: string;
  children: React.ReactNode;
};

const ContentsHeader = React.forwardRef<HTMLDivElement, Props>((props, ref): JSX.Element => {
  const {
    title,
    children,
  } = props;

  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>{title}</p>
      {children}
    </div>
  );
});

export default React.memo(ContentsHeader);
